import React from 'react';
import fr from 'facet-rest';
import { FDFacetLogo } from '@facet-wealth/design';
import useHomeContext from 'Context/HomeContext';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { NavButton } from 'Components/ClientApp/CombinedApp/Navigation/NavButton';

const FacetLogo = () => {
  const { homeResource } = useHomeContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return homeResource.withRelationship(
    fr.relationships.homePage.name,
    (rel) => {
      return (
        <NavButton
          value="logo"
          href={rel.link('related').url()}
          onClick={() => {
            logStandardizedEvent(categories.facetQuiz, eventTypes.header, eventSubTypes.clickLink);
          }}
          label={<FDFacetLogo size="md" />}
        />
      );
    },
    () => {
      return (
        <FDFacetLogo size={'md'} />
      );
    },
  );
};

export { FacetLogo };
